import type { InjectionKey } from 'vue';

import type { StoryMeta } from '#shared/types/storyblok.type';
import type { CustomerValueAddedServiceDto } from '~/apiClient';

export const INJECTION_KEYS = {
    SALES_CONTACT: Symbol('SALES_CONTACT') as InjectionKey<ComputedRef<SalesContact | undefined>>,
    STORYBLOK_STORY_META: Symbol('STORYBLOK_STORY_META') as InjectionKey<ComputedRef<StoryMeta | undefined>>,
    VALUE_ADDED_SERVICES: Symbol('VALUE_ADDED_SERVICES') as InjectionKey<Ref<CustomerValueAddedServiceDto[] | undefined>>,
} as const;
